import { DateTime } from 'luxon';
import { stringify } from 'csv-stringify/browser/esm/sync';
import type { ImportField } from '@/lib/campaign-import/column-mapping';

export interface ImportTemplateExample {
  name: string;
  notificationTitle: string;
  notificationBody: string;
  utmCampaign: string;
  labels: string;
}

export interface ImportTemplateLabels {
  headers: Record<ImportField, string>;
  /** Two example rows; their dates and links are generated, not taken from here. */
  examples: [ImportTemplateExample, ImportTemplateExample];
}

export interface ImportTemplateParams {
  storeWebsiteDomain: string;
  /** The examples launch 7 and 14 days after it, inside the valid window (today to +2 months). */
  now: DateTime;
  labels: ImportTemplateLabels;
}

const BOM = '﻿';
const EXAMPLE_OFFSETS_IN_DAYS = [7, 14] as const;
const EXAMPLE_TIMES = ['10:00', '18:30'] as const;
const EXAMPLE_PATHS = ['', 'colecao'] as const;
const COLUMNS: ImportField[] = [
  'name',
  'launchDate',
  'launchTime',
  'notificationTitle',
  'notificationBody',
  'notificationLink',
  'utmCampaign',
  'labels',
];

/** UTF-8 with BOM and `;`, which is what Excel in pt-BR opens correctly. */
export function buildImportTemplateCsv({
  storeWebsiteDomain,
  now,
  labels,
}: ImportTemplateParams): string {
  const rows = labels.examples.map((example, index) => ({
    name: example.name,
    launchDate: now
      .plus({ days: EXAMPLE_OFFSETS_IN_DAYS[index] })
      .toFormat('dd/MM/yyyy'),
    launchTime: EXAMPLE_TIMES[index],
    notificationTitle: example.notificationTitle,
    notificationBody: example.notificationBody,
    notificationLink: `https://${storeWebsiteDomain}/${EXAMPLE_PATHS[index]}`,
    utmCampaign: example.utmCampaign,
    labels: example.labels,
  }));

  const csv = stringify(rows, {
    delimiter: ';',
    header: true,
    columns: COLUMNS.map((key) => ({ key, header: labels.headers[key] })),
  });
  return `${BOM}${csv}`;
}
